import React, { useCallback } from "react";
import { string } from "prop-types";
import WistiaVideoEmbedComponent from "@insightfulscience/atomic-react/WistiaVideo/Embed";
import WistiaVideo from "@insightfulscience/atomic-react/WistiaVideo";
import { PostElementVideo } from "@insightfulscience/atomic-react/PostElement";

const Embed = ({ ...props }) => (
	<WistiaVideo>
		<WistiaVideoEmbedComponent {...props} />
	</WistiaVideo>
);

const WistiaVideoEmbed = ({ caption = "", url }) => {
	const wistiaObject =
		url.match(/https?:\/\/[^.]+\.(wistia\.com|wi\.st)\/(medias|embed)\/.*/) &&
		url.match(/(?:(?:medias|iframe)\/|wvideo=)([\w-]+)/);

	const VideoBlock = useCallback(() => {
		return caption ? (
			<PostElementVideo caption={caption}>
				<Embed id={wistiaObject[1]} />
			</PostElementVideo>
		) : (
			<Embed id={wistiaObject[1]} />
		);
	}, [caption, wistiaObject]);

	return wistiaObject ? <VideoBlock /> : null;
};

WistiaVideoEmbed.propTypes = {
	caption: string,
	url: string.isRequired,
};

export default WistiaVideoEmbed;
